import { format, parseISO } from "date-fns";

const PenultimoReciboNomina = (type, documentos) => {
  if (!documentos) return null;
  return documentos.find((doc) => doc.type === type);
};

export function parseJwt(token) {
  const parts = token.split(".");
  if (parts.length !== 3) {
    throw new Error("Token JWT inválido");
  }
  const payload = parts[1];
  const decodedPayload = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
  return JSON.parse(decodedPayload);
}

export function NumberMxn(value) {
  const formatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(value);
}

export function formatDate(value) {
  return format(parseISO(value), "yyyy-MM-dd hh:mm");
}
export default PenultimoReciboNomina;
